import zhCN from "./zh-cn";
import enUS from "./en-us";
import zhTW from "./zh-tw";

const STORAGE_KEY = "current_i18n";
const FALLBACK = "zh_CN";

const messages = {
  zh_CN: zhCN,
  en_US: enUS,
  zh_TW: zhTW,
};

function readLang() {
  try {
    return localStorage.getItem(STORAGE_KEY) || FALLBACK;
  } catch (e) {
    return FALLBACK;
  }
}

function translate(key, params) {
  const lang = readLang();
  const dict = messages[lang] || messages[FALLBACK];
  // 支持嵌套 key（如 field.please_select）
  const parts = key.split(".");
  let val = dict;
  for (const p of parts) {
    if (val && typeof val === "object" && p in val) {
      val = val[p];
    } else {
      val = undefined;
      break;
    }
  }
  if (val === undefined || val === null) {
    // fallback 到 zh_CN
    let fb = messages[FALLBACK];
    for (const p of parts) {
      if (fb && typeof fb === "object" && p in fb) {
        fb = fb[p];
      } else {
        return key; // 找不到返回 key 本身
      }
    }
    val = fb;
  }
  // 插值替换 {name} -> params.name
  if (params && typeof val === "string") {
    val = val.replace(/\{(\w+)\}/g, (m, k) => {
      return params[k] !== undefined ? params[k] : m;
    });
  }
  return val;
}

// 注入给 stempcore 子模块（field.js / input.js 等 JS 类用）
window.$sk = window.$sk || {};
window.$sk.$t = translate;
window.$sk.$lang = readLang();

export default { translate, messages, readLang };
